import { render, staticRenderFns } from "./MyFeesTab.vue?vue&type=template&id=6a846008&"
import script from "./MyFeesTab.vue?vue&type=script&lang=js&"
export * from "./MyFeesTab.vue?vue&type=script&lang=js&"
import style0 from "./MyFeesTab.vue?vue&type=style&index=0&id=6a846008&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports